import { Component, Inject, Optional,OnInit, AfterViewInit, Input,SimpleChanges, OnChanges, OnDestroy } from '@angular/core';
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

// Components
import { ModalComponent } from '../../modal/modal.component';
import { NavigationEnd } from '@angular/router/src/events';
// Material

@Component({
    selector: 'app-upload-form-modal',
    templateUrl: './upload-form-modal.component.html',
    styleUrls: ['./upload-form-modal.component.scss']
})

export class UploadFormModalComponent implements OnInit, OnChanges, OnDestroy {

  public sectionToShow: number = 1;
  public newOrder: boolean = false;
  constructor(private dialogRef: MatDialogRef<UploadFormModalComponent>,   
   @Optional() @Inject(MAT_DIALOG_DATA) public data: any

  ) {  
    if (data && data.newOrder !== undefined)
      this.newOrder = data.newOrder;
  }  


 ngOnInit(): void {       
        
      }

 ngOnChanges(changes: SimpleChanges): void {
  
        if (changes['sectionModal']) {
            const newValue = changes['sectionModal'].currentValue;           
            this.sectionToShow = newValue; 
        }
  }

  ngOnDestroy() {
    
  }
onCancel(): void {
    this.dialogRef.close(); 
  }

  onClose(): void {    
    this.dialogRef.close(); 
  }

  onSave(): void {
    const result = { success: true, message: 'Form saved successfully' };
    this.dialogRef.close(result); 
  }

   openVideoTutorialModal() {         
    this.sectionToShow = 2;     
  } 
   
}
